window.Livewire = Livewire
import Vue from 'vue';

import Checkout from './components/Checkout'

if (document.getElementById("checkout")) {
    new Vue({
        el: "#checkout",
        components: {
            Checkout
        }
    });
}
